<h1 mat-dialog-title>
  {{ 'properties.dialog.docEditSameCodeTitle' | translate }} {{ barCode }}
</h1>
<mat-dialog-content>
  <div class="mt-1 mb-3 ml-3">
    {{ 'properties.dialog.docEditSameCodeIntro' | translate }}
  </div>

  <table class="table table-borderless table-striped">
    <thead>
      <tr>
        <th></th>
        <th>{{ 'properties.documentsPage.docType' | translate }}</th>
        <th>{{ 'properties.structures.structure' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let choice of choices; trackBy: trackBySubDocId">
        <td>
          <mat-checkbox [checked]="!!checked[choice.subDocId]" [disabled]="choice.lockReason !== null"
            (change)="onToggle(choice, $event.checked)" class="checkbox-insert">
          </mat-checkbox>
        </td>
        <td>
          {{ choice.docTitle || choice.key }}
          <!-- Nothing is ticked on opening: this tells which row the edit was opened from -->
          <div class="same-code-note" *ngIf="choice.isClicked">
            {{ 'properties.dialog.docEditSameCodeClicked' | translate }}
          </div>
          <!-- Written in the row, not in a tooltip: readable without hovering, on tablets too -->
          <div class="same-code-note same-code-lock" *ngIf="lockMessages[choice.subDocId]">
            {{ lockMessages[choice.subDocId] }}
          </div>
        </td>
        <td>
          {{ choice.area }} {{ choice.subArea }} {{ choice.structureObjectName }}
        </td>
      </tr>
    </tbody>
  </table>
</mat-dialog-content> <!-- mat-dialog-content -->
<div class="col-12 pb-4" mat-dialog-actions>
  <div class="col-6 text-left">
    <div class="w-100">
      <a mat-button (click)="onClose()" mat-raised-button mat-default
        class="ml-3">{{ 'common.cta.close' | translate }}</a>
    </div>
  </div>
  <div class="col-6 text-right" *ngIf="checkedCount">
    <button mat-raised-button color="primary" type="button" (click)="onContinue()">
      {{ 'common.cta.continue' | translate }}
    </button>
  </div>
</div>
